export default function getUrlParams(search) {
	let hashes;

	if(search.indexOf('?') >-1) {
  		hashes = search.slice(search.indexOf('?') + 1).split('&');
	}else {
		return {};
	}


  return hashes.reduce((params, hash) => {
      let [key, val] = hash.split('=')
      return Object.assign(params, {[key]: decodeURIComponent(val)})
  }, {})
}


// WEBPACK FOOTER //
// ./js/src/getUrlParams.js